export default "/images/344cae417143dfc87fc204209282fb87.avif";